import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "ml-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = {
  key: 2,
  class: "col-span-2 w-full"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "inputTitle" }
const _hoisted_24 = { class: "inputField flex-grow flex items-center" }
const _hoisted_25 = ["value"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "icon-clipboard" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]

import {useI18n} from "vue-i18n";
import {Ref, toRef} from "vue";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import {TicketType} from "@/utilities/enums/Enums";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {baseURL} from "@/AppConfig";
import {$t} from "@/utilities/i18n/config";
import {notify} from "@kyvg/vue3-notification";
import Ticket from "@/models/entities/Ticket";


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketDetailPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const props = __props
const popupData = toRef(props, 'data') as Ref<Ticket>;

const copyToClipboard = async () => {
  const url = `${baseURL}/external/${popupData.value?.urlToken}`;

  try {
    await navigator.clipboard.writeText(url);
    notify({
      title: "",
      text: $t('general.copied'),
      duration: 2000,
      type: "success"
    });
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (popupData.value.type !== _unref(TicketType).staticDownload)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.recipient")) + ": ", 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(`${popupData.value.recipient.fullName} ${popupData.value.recipient.email ? `(${popupData.value.recipient.email})` : ''}`) + " " + _toDisplayString(""/*TODO work on staticListDetails*/), 1)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.sendByTool")) + ": ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popupData.value.recipients, (recipient) => {
            return (_openBlock(), _createElementBlock("div", {
              key: recipient.id,
              class: "ml-2"
            }, _toDisplayString(`${recipient.displayName} ${recipient.email ? `(${recipient.email})` : ''}`), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popupData.value.recipientlists, (recipientlist) => {
            return (_openBlock(), _createElementBlock("div", {
              key: recipientlist.id,
              class: "ml-2"
            }, _toDisplayString(`${recipientlist.name} (${recipientlist.recipientCount})`), 1))
          }), 128))
        ])),
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.creator")) + ": ", 1),
    _createElementVNode("span", _hoisted_5, _toDisplayString(popupData.value.creator.displayName), 1),
    _hoisted_6,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.type")) + ": ", 1),
    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)(`dashboard.tabs.ticket.popups.edit.types.${_unref(TicketType)[popupData.value.type]}`)), 1),
    _hoisted_8,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.changedBy")) + ": ", 1),
    _createElementVNode("span", _hoisted_9, _toDisplayString(popupData.value.modifiedBy), 1),
    _hoisted_10,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.changed")) + ": ", 1),
    _createElementVNode("span", _hoisted_11, _toDisplayString(popupData.value.modifiedAt ? _unref(DateToStringHelper)(new Date(popupData.value.modifiedAt)) : ""), 1),
    _hoisted_12,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.validToDate")) + ": ", 1),
    _createElementVNode("span", _hoisted_13, _toDisplayString(popupData.value.validity.expiresAt  ? _unref(DateToStringHelper)(new Date(popupData.value.validity.expiresAt)) : ""), 1),
    _hoisted_14,
    _hoisted_15,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.urlGuid")) + ": ", 1),
    _createElementVNode("span", _hoisted_16, _toDisplayString(popupData.value.urlToken), 1),
    _hoisted_17,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.totalAttempts")) + ": ", 1),
    _createElementVNode("span", _hoisted_18, _toDisplayString(popupData.value.security.totalAttempts), 1),
    _hoisted_19,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.ticket.popups.details.attemptsRemaining")) + ": ", 1),
    _createElementVNode("span", _hoisted_20, _toDisplayString(popupData.value.security.attemptsRemaining), 1),
    (popupData.value.type === _unref(TicketType).staticDownload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref($t)('dashboard.tabs.file.popups.edit.staticLink')), 1),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("input", {
              type: "text",
              value: _unref(NullOrUndefinedHelper)(popupData.value.urlToken) ? '' : `${_unref(baseURL)}/external/${popupData.value.urlToken}`,
              class: "flex-1 mr-0",
              disabled: true
            }, null, 8, _hoisted_25),
            _createElementVNode("button", {
              onClick: copyToClipboard,
              class: "btn primary m-0 p-0 h-[44px] min-w-[44px] flex justify-center items-center",
              disabled: _unref(NullOrUndefinedHelper)(popupData.value.urlToken)
            }, _hoisted_28, 8, _hoisted_26)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})